import React from 'react';
import { Flex, HStack, Text } from '@chakra-ui/react';
import type { MarketplaceProfilePackageDeliverable } from '@foodfluence/shared';
import { deliverableIsCarousel } from '@foodfluence/shared';
import { ff } from '../../../../../../theme';
import { InstagramPlatformChip, TikTokPlatformChip, UgcPackageIcon } from './PackagePlatformChips';
import { deliverableToPlatformType, labelForDeliverable } from '../../lib/packageMapping';

type Props = {
  deliverables: MarketplaceProfilePackageDeliverable[];
};

function DeliverableItem({ d }: { d: MarketplaceProfilePackageDeliverable }) {
  const { platform } = deliverableToPlatformType(d);
  const isCarousel = deliverableIsCarousel(d.type);
  const photoCount = d.count ?? 2;

  return (
    <HStack
      as="span"
      display="inline-flex"
      alignItems="center"
      spacing="5px"
      maxW="100%"
      minW={0}
      flexWrap="wrap"
      rowGap="2px"
    >
      <Text
        as="span"
        fontSize={{ base: '14px', sm: '15px' }}
        fontWeight="500"
        lineHeight="20px"
        color={ff.ink}
        flexShrink={0}
      >
        {d.quantity}×
      </Text>
      {platform === 'instagram' ? (
        <InstagramPlatformChip />
      ) : platform === 'tiktok' ? (
        <TikTokPlatformChip />
      ) : (
        <UgcPackageIcon />
      )}
      <Text
        as="span"
        fontSize={{ base: '14px', sm: '15px' }}
        fontWeight="500"
        lineHeight="20px"
        color={ff.ink}
        minW={0}
      >
        {labelForDeliverable(d)}
      </Text>
      {isCarousel && (
        <Text
          as="span"
          fontSize={{ base: '13px', sm: '14px' }}
          fontWeight="500"
          lineHeight="20px"
          color={ff.text2}
          flexShrink={0}
        >
          {photoCount} photos
        </Text>
      )}
    </HStack>
  );
}

/** Deliverable summary for package list rows — wraps inline at all breakpoints. */
const PackageComposition: React.FC<Props> = ({ deliverables }) => {
  if (deliverables.length === 0) return null;

  return (
    <Flex
      as="span"
      display="inline-flex"
      flexWrap="wrap"
      alignItems="center"
      rowGap="8px"
      columnGap="12px"
      maxW="100%"
      w="100%"
      minW={0}
    >
      {deliverables.map((d, i) => (
        <DeliverableItem key={`${d.type}-${i}`} d={d} />
      ))}
    </Flex>
  );
};

export default PackageComposition;
